export const BUSINESS = {
    TYPE_OPTIONS: [
        'cafe',
        'bar',
        'culture',
        'verein',
        'restaurant',
        'sport',
        'bookstore',
        'floristics',
        'interior',
        'fashion',
        'services',
        'retail',
        'other',
    ],
};
